import { render, staticRenderFns } from "./sight.vue?vue&type=template&id=56c10483&"
import script from "./sight.js?vue&type=script&lang=js&"
export * from "./sight.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports